import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AlertService, GroupService, OperatorService, UserService} from "../services";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

import {Router, ActivatedRoute} from '@angular/router';
import {finalize, first} from 'rxjs/operators';
import {ProductService} from "../services/product.service";
import {CategoryService} from "../services/category.service";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {CategoryDialogComponent} from "../category/dialog/categoryDialog.component";
import {VatRateService} from "../services/vatRate.service";
import {UnitService} from "../services/unit.services";
import {ManufacturerService} from "../services/manufacturer.service";

import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {ServiceService} from "../services/service.service";
import {Service} from "../models/service";
import {Gallery} from "../cms/gallery/model/gallery";
import {Subscription} from "rxjs";
import {GalleryService} from "../cms/gallery/service/gallery.service";
import {HttpEventType} from "@angular/common/http";
import {GalleryItem} from "../cms/gallery/model/galleryItem";
import {UpdateGalleryItemDialogComponent} from "../cms/gallery/dialog/updateGalleryItemDialog.component";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
    templateUrl: './serviceForm.component.html',
    styleUrls: ['./serviceForm.component.scss']
})

export class ServiceFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    categories: any[];
    vatRates: any[];
    resources: any[];
    units: any[];
    dialogRef: any;
    images: any[];
    documents: any[];
    resourcesForm: any[] = [];
    serviceData: Service;
    gallery: Gallery;
    loadingIndicator: boolean;
    @ViewChild("fileDropRef", {static: false}) fileDropEl: ElementRef;
    files: any[] = [];
    uploadSub: Subscription;
    items: string[] = [];
    checkedResources = [];
    saving: boolean = false;
    serviceTypes = [
        {
            "id": "FITNESS_TRAINING",
            "name": "Fitness training"
        },
        {
            "id": "PERSONAL_TRAINING",
            "name": "Personal training"
        },
        {
            "id": "EMS_TRAINING",
            "name": "EMS training"
        },
        {
            "id": "UNATTENDED_TRAINING",
            "name": "Unattended training"
        },
        {
            "id": "SERVICE_TRAINING",
            "name": "Service training"
        }
    ]

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private productService: ProductService,
        private alertService: AlertService,
        private categoryService: CategoryService,
        private vatRateService: VatRateService,
        private unitService: UnitService,
        private manufacturerService: ManufacturerService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private serviceService: ServiceService,
        private galleryService: GalleryService,
        private _matSnackBar: MatSnackBar,
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Services');
    }

    ngOnInit() {
        this.resources = this.route.snapshot.data.resources;
        this.vatRates = this.route.snapshot.data.vatRates;
        this.categories = this.route.snapshot.data.categories;

        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
            this.galleryService.getByObject(this.id, 'Service').subscribe((gallery: Gallery) => {
                this.gallery = gallery;

                for (let i = 0; i < this.gallery.items.length; i++) {
                    this.galleryService.getImageById(this.gallery.id, this.gallery.items[i].id).pipe(first())
                        .subscribe((item: string) => {
                            this.gallery.items[i].image = item;
                        });
                }
            }, error => {

            });
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            description: [''],
            category: [''],
            vatRate: [''],
            privateDescription: [''],
            onlineReservation: [''],
            popularity: [''],
            requiredTime: [''],
            priceNet: [''],
            priceGross: [''],
            purchasePriceNet: [''],
            purchasePriceGross: [''],
            blockedTimeBeforeService: [''],
            blockedTimeAfterService: [''],
            breakTimeInService: [''],
            promotion: [''],
            groupTraining: [false],
            requiredCredits: [0],
            resourceGroups: this.formBuilder.array([]),
            resources: this.formBuilder.array([]),
            type: [''],
        });

        this.serviceData = new Service();

        if (!this.isAddMode) {
            this.serviceData = this.route.snapshot.data.service;

            this.f.name.setValue(this.serviceData.name);

            if (this.serviceData.category) {
                this.f.category.setValue(this.serviceData.category.id);
            }

            if (typeof this.serviceData.vatRate !== "undefined" && this.serviceData.vatRate !== null) {
                this.f.vatRate.setValue(this.serviceData.vatRate.id);
            }

            let r = [];
            for (let i = 0; i < this.serviceData.resources.length; i++) {
                this.checkedResources.push(this.serviceData.resources[i].id);
                r.push(this.serviceData.resources[i]);
            }

            this.f.requiredTime.setValue(this.serviceData.requiredTime);
            this.f.blockedTimeBeforeService.setValue(this.serviceData.blockedTimeBeforeService);
            this.f.blockedTimeAfterService.setValue(this.serviceData.blockedTimeAfterService);
            this.f.breakTimeInService.setValue(this.serviceData.breakTimeInService);
            this.f.popularity.setValue(this.serviceData.popularity);
            this.f.priceGross.setValue(this.serviceData.priceGross);
            this.f.privateDescription.setValue(this.serviceData.privateDescription);
            this.f.description.setValue(this.serviceData.description);
            this.f.promotion.setValue(this.serviceData.promotion);
            this.f.groupTraining.setValue(this.serviceData.groupTraining);
            this.f.onlineReservation.setValue(this.serviceData.onlineReservation);
            this.f.requiredCredits.setValue(this.serviceData.requiredCredits);
            this.f.type.setValue(this.serviceData.type);

            const resources: FormArray = new FormArray([...r.map(item => new FormControl(item))]);
            this.form.setControl('resources', resources);
            // this.f.resources.setValue(resources);

            for (let i = 0; i < this.serviceData.resourceGroups.length; i++) {
                this.addResourceGroup();

                for (let j = 0; j < this.serviceData.resourceGroups[i].resources.length; j++) {
                    this.addResource(i);
                    this.setResourceValue(i, j, this.serviceData.resourceGroups[i].resources[j].id);
                }
            }
        }
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    resourceGroups(): FormArray {
        return this.form.get('resourceGroups') as FormArray;
    }

    newResourceGroup(): FormGroup {
        return this.formBuilder.group({
            id: [''],
            resources: this.formBuilder.array([])
        });
    }

    addResourceGroup() {
        this.resourceGroups().push(this.newResourceGroup());
    }

    removeResourceGroup(resourceGroupIdx: number) {
        this.resourceGroups().removeAt(resourceGroupIdx);
    }

    resourceGroupResources(resourceGroupIdx: number): FormArray {
        return this.resourceGroups().at(resourceGroupIdx).get('resources') as FormArray;
    }

    newResource(): FormGroup {
        return this.formBuilder.group({
            id: ['']
        });
    }

    addResource(resourceGroupIdx: number) {
        this.resourceGroupResources(resourceGroupIdx).push(this.newResource());
    }

    removeResource(resourceGroupIdx: number, resourceIdx: number) {
        this.resourceGroupResources(resourceGroupIdx).removeAt(resourceIdx);
    }

    setResourceValue(resourceGroupIdx: number, resourceIdx: number, value: string) {
        this.resourceGroupResources(resourceGroupIdx).at(resourceIdx).get('id').setValue(value);
    }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.saving = true;

        if (this.isAddMode) {
            this.createService();
        } else {
            this.updateService();
        }
    }

    public addCategory() {
        this.dialogRef = this._matDialog.open(CategoryDialogComponent, {
            panelClass: 'contact-form-dialog',
            data: {
                action: 'new',
                categories: this.categories,
            }
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                let category = response.getRawValue();
                category.type = 'service';

                this.categoryService.create(category)
                    .pipe(first())
                    .subscribe(
                        data => {
                            this.alertService.success('Category added successfully', {keepAfterRouteChange: true});

                            this.categoryService.getAllByType('service').subscribe((res: any[]) => {
                                this.categories = res;
                            }, error => {
                                this.alertService.error(error);
                            });
                        },
                        error => {
                            this.alertService.error(error);
                            this.loading = false;
                        });

            }, (err) => {
                console.log(err);
            });
    }

    private createService() {
        let service = this.form.value;
        service.images = this.images;
        service.documents = this.documents;

        this.serviceService.create(service)
            .pipe(first())
            .subscribe(
                data => {
                    // this.alertService.success('Service added successfully', { keepAfterRouteChange: true });
                    // this.router.navigate(['.', { relativeTo: this.route }]);
                    this.saving = false;

                    this._matSnackBar.open('Service data saved!', 'OK', {
                        verticalPosition: 'top',
                        duration: 5000,
                        panelClass: ['snackbar-success']
                    });
                },
                error => {
                    // this.alertService.error(error);
                    this.loading = false;
                    this.saving = false;

                    this._matSnackBar.open(error, 'OK', {
                        verticalPosition: 'top',
                        duration: 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }

    private updateService() {
        let service = this.form.value;
        service.images = this.images;
        service.documents = this.documents;

        this.serviceService.update(this.id, service)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful', {keepAfterRouteChange: true});
                    this.saving = false;
                    // this.router.navigate(['..', { relativeTo: this.route }]);

                    this._matSnackBar.open('Service data saved!', 'OK', {
                        verticalPosition: 'top',
                        duration: 5000,
                        panelClass: ['snackbar-success']
                    });
                },
                error => {
                    // this.alertService.error(error);
                    this.loading = false;
                    this.saving = false;

                    this._matSnackBar.open(error, 'OK', {
                        verticalPosition: 'top',
                        duration: 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }

    onImagesChange(event) {
        this.images = [];
        if (event.target.files && event.target.files.length) {
            const files = event.target.files;
            let a = Array.from(files);

            for (let i = 0; i < files.length; i++) {
                let reader = new FileReader();

                reader.readAsDataURL(files[i]);

                reader.onload = () => {
                    this.images.push({
                        "content": reader.result,
                        "name": files[i].name,
                        "size": files[i].size,
                        "type": files[i].type,
                        "objectReference": "",
                        "referenceId": ""
                    });
                };
            }
        }
    }

    onDocumentsChange(event) {
        this.documents = [];
        if (event.target.files && event.target.files.length) {
            const files = event.target.files;
            let a = Array.from(files);

            for (let i = 0; i < files.length; i++) {
                let reader = new FileReader();

                reader.readAsDataURL(files[i]);

                reader.onload = () => {
                    this.documents.push({
                        "content": reader.result,
                        "name": files[i].name,
                        "size": files[i].size,
                        "type": files[i].type,
                        "objectReference": "",
                        "referenceId": ""
                    });
                };
            }
        }
    }

    compareObjects(o1: any, o2: any): boolean {
        return o1.name === o2.name && o1.id === o2.id;
    }

    /**
     * on file drop handler
     */
    onFileDropped($event) {
        this.prepareFilesList($event);
    }

    /**
     * handle file from browsing
     */
    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }

    /**
     * Convert Files list to normal array list
     * @param files (Files List)
     */
    prepareFilesList(files: Array<any>) {
        for (const item of files) {
            item.progress = 0;
            this.files.push(item);
        }
        this.fileDropEl.nativeElement.value = "";
        this.uploadFilesSimulator(0);
    }

    /**
     * Simulate the upload process
     */
    uploadFilesSimulator(index: number) {
        if (index === this.files.length) {
            return;
        } else {
            const formData = new FormData();
            formData.append("image", this.files[index]);
            formData.append("gallery", this.gallery.id);

            const upload$ = this.galleryService.uploadFile(formData).pipe(
                finalize(() => {
                    this.reset();
                    this.deleteFile(index);
                })
            );

            this.uploadSub = upload$.subscribe(event => {
                if (event.type == HttpEventType.UploadProgress) {
                    this.files[index].progress = Math.round(100 * (event.loaded / event.total));
                }
            })
        }
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        if (this.files[index].progress < 100) {
            console.log("Upload in progress.");
            return;
        }
        this.files.splice(index, 1);
    }

    reset() {
        this.uploadSub = null;
        this.items = [];

        this.galleryService.getById(this.gallery.id).pipe(first()).subscribe((gallery: Gallery) => {
            this.gallery = gallery;

            for (let i = 0; i < this.gallery.items.length; i++) {
                this.galleryService.getImageById(this.gallery.id, this.gallery.items[i].id).pipe(first())
                    .subscribe((item: string) => {
                        this.items.push(item);
                    });
            }
        });


    }

    cancelUpload() {
        this.uploadSub.unsubscribe();
        this.reset();
    }

    /**
     * format bytes
     * @param bytes (File size in bytes)
     * @param decimals (Decimals point)
     */
    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return "0 Bytes";
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    showGalleryItemDialog(galleryItem: GalleryItem) {
        this.dialogRef = this._matDialog.open(UpdateGalleryItemDialogComponent, {
            panelClass: 'update-gallery-item-dialog',
            data: {
                action: 'show',
                galleryItem: galleryItem,
            },
            width: '650px',
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    this.reset();
                    return;
                }

                // this.galleryService.delete(event.id).pipe(first())
                //     .subscribe(res => {
                //         window.location.reload();
                //     });

                this.dialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    onChange(selectedOption: MatCheckboxChange) {
        const interests = (<FormArray>(
            this.form.get("resources")
        )) as FormArray;

        if (selectedOption.checked) {
            interests.push(new FormControl(selectedOption.source.value));
        } else {
            const i = interests.controls.findIndex(
                x => x.value === selectedOption.source.value
            );
            interests.removeAt(i);
        }
    }
}
